/**
 * Split Section Slider — auto-cycling image slider with crossfade.
 * No controls, no dots — purely atmospheric.
 */
class OdeSplitSlider {
  constructor(element) {
    this.element = element;
    this.slides = element.querySelectorAll('.ode-split__slide');
    this.interval = parseInt(element.dataset.interval || '5', 10) * 1000;
    this.current = 0;
    this.timer = null;

    if (this.slides.length < 2) return;

    this.start();
  }

  start() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.timer = setInterval(function() { this.next(); }.bind(this), this.interval);
  }

  next() {
    this.slides[this.current].classList.remove('is-active');
    this.current = (this.current + 1) % this.slides.length;
    this.slides[this.current].classList.add('is-active');
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.ode-split__slider').forEach(function(slider) {
    new OdeSplitSlider(slider);
  });
});
